/**
 * Created by Damien Broqua on 16/12/2015.
 */

export const GUIConstants = {
    WALL_THICKNESS: 'thickness',
    WALL_HEIGHT: 'height',
    ROOM_AREA: 'area',
    ROOM_HEIGHT: 'roomHeight',
    SHUTTER: 'shutter',
    JOINERY_HEIGHT: 'height',
    JOINERY_WIDTH: 'length',
    JOINERY_FLOOR_HEIGHT: 'floorHeight',
    NB_DOORS: 'nbDoors',
    NB_CASEMENTS: 'nbCasement',
    OPENING_MODE: 'openingMode',
    OPENING_ORIENTATION: 'orientation',
    OPENING_RIGHT_ORIENTATION: 'rightorientation',
    HINGES_POSITION: 'handleSide',
    FUNCTIONALITY_MAIN_ID: 'mainFunctionality',
    IMPORT_MAX_PHOTO: 64,
    LATERAL_PANEL_SIZE: 300
};
